import React from 'react';
import { titleize } from 'inflection';

import styles from './onboardingCommunitySuggestionCardStyles';

import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';
import AnonEmployerAssociation from 'buyside/components/presentation/EmployerAssociation/anonEmployerAssociation';
import FollowButton, {
  FollowableType
} from 'buyside/components/presentation/FollowButton/followButton';
import { BUTTON_SIZES } from 'buyside/components/presentation/Button/button';

import { get } from 'buyside/util/lodashAltJs';
import { defaultUserImageUrl } from 'buyside/util/urlHelper';

class OnboardingCommunitySuggestionCard extends React.Component {
  constructor() {
    super();
  }

  render() {
    const { suggestion = {}, showUserDetails } = this.props;

    const {
      id,
      displayName,
      profileImageUrl,
      currentEmployerName,
      publishedIdeasCount,
      featuredRankForCurrentUserWatchlist,
      wroteOnWatchlistedSectors,
      sectorsWroteOn
    } = suggestion;

    const { aumRange, fundType } = get(suggestion, ['mostRecentEmployer', 'employer'], {});

    return (
      <div className={styles.communityCardContainer} id="community-card">
        <div className={styles.communityCard}>
          <div>
            <div className={styles.followButtonContainer}>
              <FollowButton
                size={BUTTON_SIZES.TINIEST}
                id={id}
                type={FollowableType.USER}
                key={id}
              />
            </div>
            <div className={styles.profileImage}>
              <ProfileImage
                source={showUserDetails ? profileImageUrl : defaultUserImageUrl()}
                size="medium"
              />
            </div>
          </div>
          <div>
            <div>
              {showUserDetails ? (
                displayName
              ) : (
                <AnonymousUserDisplay
                  anonUser={{ title: get(suggestion, ['mostRecentEmployer', 'title']) }}
                />
              )}
            </div>
            <div className={styles.employerName}>
              {showUserDetails ? (
                currentEmployerName
              ) : (
                <AnonEmployerAssociation aumRange={aumRange} fundType={fundType} />
              )}
            </div>
            {featuredRankForCurrentUserWatchlist && (
              <div className={styles.rank}>
                Ranked <strong>#{featuredRankForCurrentUserWatchlist.value + 1}</strong>
                &nbsp;in{' '}
                <strong>
                  {featuredRankForCurrentUserWatchlist.category === 'general'
                    ? 'All-Time'
                    : titleize(featuredRankForCurrentUserWatchlist.category)}
                </strong>
              </div>
            )}
            {Boolean(wroteOnWatchlistedSectors) && (
              <div className={styles.watchlistedSectors}>
                Wrote <strong>{wroteOnWatchlistedSectors}</strong>
                &nbsp;idea{wroteOnWatchlistedSectors > 1 ? 's' : ''} on your preferred sectors:
              </div>
            )}
            {sectorsWroteOn && (
              <div className={styles.sectors}>
                {sectorsWroteOn.map(sector => (
                  <div key={sector} className={styles.sectorCard}>
                    {sector}
                  </div>
                ))}
              </div>
            )}
            {Boolean(publishedIdeasCount) && (
              <div className={styles.ideaCount}>
                <strong>{publishedIdeasCount}</strong> Published Idea
                {publishedIdeasCount > 1 ? 's' : ''}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default OnboardingCommunitySuggestionCard;
